import React from 'react';

import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';

import { prefixByChannel } from '../../routes/prefixes';
import { setActiveChannel } from '../../ducks/channels';

import FieldRadioGroupBar from '../../components/fields/fieldRadioGroupBar/FieldRadioGroupBar';
import ChannelLink from './ChannelLink';

@withRouter
@connect(({ channels }) => ({ ...channels }))
export default class ChannelToggle extends React.PureComponent {
  navigateToResource = (channel) => {
    const { activeChannel, alternateResources, location } = this.props;

    if (alternateResources && alternateResources[channel]) {
      browserHistory.push(ChannelLink.formatLink(channel, alternateResources[channel].path));
      return;
    }

    let currentRouteWithoutPrefix = '/';
    if (!alternateResources && location.pathname) {
      const isPrefixed = prefixByChannel[activeChannel];

      if (isPrefixed) {
        const [, ...routeParts] = location.pathname.split('/').filter((it) => !!it);

        if (routeParts.length) {
          currentRouteWithoutPrefix = `/${routeParts.join('/')}${location.search}`;
        }
      } else {
        currentRouteWithoutPrefix = `${location.pathname}${location.search}`;
      }
    }

    browserHistory.push(ChannelLink.formatLink(channel, currentRouteWithoutPrefix));
  };

  onChannelClick = (channel) => {
    const { dispatch, onChannelSelected } = this.props;

    dispatch(setActiveChannel(channel));
    this.navigateToResource(channel);
    onChannelSelected && onChannelSelected(channel);
  };

  render() {
    const { activeChannel, availableChannels } = this.props;

    return (
      <FieldRadioGroupBar
        choices={Object.entries(availableChannels)
          .map(([code, channel]) => ({
            code,
            label: channel.regionName,
          }))
          .reverse()}
        input={{
          name: 'channel-toggle',
          value: activeChannel,
          onChange: (evt) => this.onChannelClick(evt.target.value),
        }}
        compact
      />
    );
  }
}



// WEBPACK FOOTER //
// ./containers/channelUtils/ChannelToggle.js